// Generated by purs version 0.14.3
"use strict";
var Control_Apply = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Apply.purs");
var Control_Monad_Reader_Trans = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Reader/Trans.purs");
var Control_Monad_Writer_Trans = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Writer/Trans.purs");
var Data_Array = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/arrays/v6.0.1/src/Data/Array.purs");
var Data_Codec = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec/v4.0.1/src/Data/Codec.purs");
var Data_Codec_Argonaut = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec-argonaut/v8.0.0/src/Data/Codec/Argonaut.purs");
var Data_Codec_Argonaut_Sum = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec-argonaut/v8.0.0/src/Data/Codec/Argonaut/Sum.purs");
var Data_Either = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/either/v5.0.0/src/Data/Either.purs");
var Data_Foldable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foldable-traversable/v5.0.1/src/Data/Foldable.purs");
var Data_Functor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Functor.purs");
var Data_Identity = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/identity/v5.0.0/src/Data/Identity.purs");
var Data_List = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/lists/v6.0.1/src/Data/List.purs");
var Data_List_Types = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/lists/v6.0.1/src/Data/List/Types.purs");
var Data_Map_Internal = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/ordered-collections/v2.0.1/src/Data/Map/Internal.purs");
var Data_Maybe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/maybe/v5.0.0/src/Data/Maybe.purs");
var Data_Profunctor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/profunctor/v5.0.0/src/Data/Profunctor.purs");
var Data_Tuple = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/tuples/v6.0.1/src/Data/Tuple.purs");
var Data_Unfoldable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/unfoldable/v5.0.0/src/Data/Unfoldable.purs");
var Foreign_Object = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-object/v3.0.0/src/Foreign/Object.purs");
var tuple = function (codecA) {
    return function (codecB) {
        return Data_Codec_Argonaut.indexedArray("Tuple")(Control_Apply.apply(Data_Codec.applyGCodec(Control_Monad_Reader_Trans.applyReaderT(Data_Either.applyEither))(Control_Monad_Writer_Trans.applyWriterT(Data_List_Types.semigroupList)(Data_Identity.applyIdentity)))(Data_Functor.map(Data_Codec.functorGCodec(Control_Monad_Reader_Trans.functorReaderT(Data_Either.functorEither))(Control_Monad_Writer_Trans.functorWriterT(Data_Identity.functorIdentity)))(Data_Tuple.Tuple.create)(Data_Profunctor.lcmap(Data_Codec.profunctorGCodec(Control_Monad_Reader_Trans.functorReaderT(Data_Either.functorEither))(Control_Monad_Writer_Trans.functorWriterT(Data_Identity.functorIdentity)))(Data_Tuple.fst)(Data_Codec_Argonaut.index(0)(codecA))))(Data_Profunctor.lcmap(Data_Codec.profunctorGCodec(Control_Monad_Reader_Trans.functorReaderT(Data_Either.functorEither))(Control_Monad_Writer_Trans.functorWriterT(Data_Identity.functorIdentity)))(Data_Tuple.snd)(Data_Codec_Argonaut.index(1)(codecB))));
    };
};
var maybe = function (codec) {
    var printTag = function (v) {
        if (!v) {
            return "Nothing";
        };
        if (v) {
            return "Just";
        };
        throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 27, column 14 - line 29, column 18): " + [ v.constructor.name ]);
    };
    var parseTag = function (v) {
        if (v === "Nothing") {
            return new Data_Maybe.Just(false);
        };
        if (v === "Just") {
            return new Data_Maybe.Just(true);
        };
        return Data_Maybe.Nothing.value;
    };
    var enc = function (v) {
        if (v instanceof Data_Maybe.Nothing) {
            return new Data_Tuple.Tuple(false, Data_Maybe.Nothing.value);
        };
        if (v instanceof Data_Maybe.Just) {
            return new Data_Tuple.Tuple(true, new Data_Maybe.Just(Data_Codec.encode(codec)(v.value0)));
        };
        throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 37, column 9 - line 39, column 48): " + [ v.constructor.name ]);
    };
    var dec = function (v) {
        if (!v) {
            return new Data_Either.Left(Data_Maybe.Nothing.value);
        };
        if (v) {
            return new Data_Either.Right((function () {
                var $20 = Data_Functor.map(Data_Either.functorEither)(Data_Maybe.Just.create);
                var $21 = Data_Codec.decode(codec);
                return function ($22) {
                    return $20($21($22));
                };
            })());
        };
        throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 34, column 9 - line 36, column 47): " + [ v.constructor.name ]);
    };
    return Data_Codec_Argonaut_Sum.taggedSum("Maybe")(printTag)(parseTag)(dec)(enc);
};
var map = function (dictOrd) {
    return function (codecA) {
        var $23 = Data_Profunctor.dimap(Data_Codec.profunctorGCodec(Control_Monad_Reader_Trans.functorReaderT(Data_Either.functorEither))(Control_Monad_Writer_Trans.functorWriterT(Data_Identity.functorIdentity)))(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray))(Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray));
        var $24 = tuple(codecA);
        return function ($25) {
            return $23(Data_Codec_Argonaut.array($24($25)));
        };
    };
};
var list = (function () {
    var $26 = Data_Profunctor.dimap(Data_Codec.profunctorGCodec(Control_Monad_Reader_Trans.functorReaderT(Data_Either.functorEither))(Control_Monad_Writer_Trans.functorWriterT(Data_Identity.functorIdentity)))(Data_Array.fromFoldable(Data_List_Types.foldableList))(Data_List.fromFoldable(Data_Foldable.foldableArray));
    return function ($27) {
        return $26(Data_Codec_Argonaut.array($27));
    };
})();
var foreignObject = (function () {
    var $28 = Data_Profunctor.dimap(Data_Codec.profunctorGCodec(Control_Monad_Reader_Trans.functorReaderT(Data_Either.functorEither))(Control_Monad_Writer_Trans.functorWriterT(Data_Identity.functorIdentity)))(Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray))(Foreign_Object.fromFoldable(Data_Foldable.foldableArray));
    var $29 = tuple(Data_Codec_Argonaut.string);
    return function ($30) {
        return $28(Data_Codec_Argonaut.array($29($30)));
    };
})();
var either = function (codecA) {
    return function (codecB) {
        var printTag = function (v) {
            if (v) {
                return "Left";
            };
            if (!v) {
                return "Right";
            };
            throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 54, column 14 - line 56, column 20): " + [ v.constructor.name ]);
        };
        var parseTag = function (v) {
            if (v === "Left") {
                return new Data_Maybe.Just(true);
            };
            if (v === "Right") {
                return new Data_Maybe.Just(false);
            };
            return Data_Maybe.Nothing.value;
        };
        var enc = function (v) {
            if (v instanceof Data_Either.Left) {
                return new Data_Tuple.Tuple(true, new Data_Maybe.Just(Data_Codec.encode(codecA)(v.value0)));
            };
            if (v instanceof Data_Either.Right) {
                return new Data_Tuple.Tuple(false, new Data_Maybe.Just(Data_Codec.encode(codecB)(v.value0)));
            };
            throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 64, column 9 - line 66, column 51): " + [ v.constructor.name ]);
        };
        var dec = function (v) {
            if (v) {
                return new Data_Either.Right((function () {
                    var $31 = Data_Functor.map(Data_Either.functorEither)(Data_Either.Left.create);
                    var $32 = Data_Codec.decode(codecA);
                    return function ($33) {
                        return $31($32($33));
                    };
                })());
            };
            if (!v) {
                return new Data_Either.Right((function () {
                    var $34 = Data_Functor.map(Data_Either.functorEither)(Data_Either.Right.create);
                    var $35 = Data_Codec.decode(codecB);
                    return function ($36) {
                        return $34($35($36));
                    };
                })());
            };
            throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 61, column 9 - line 63, column 50): " + [ v.constructor.name ]);
        };
        return Data_Codec_Argonaut_Sum.taggedSum("Either")(printTag)(parseTag)(dec)(enc);
    };
};
module.exports = {
    either: either,
    foreignObject: foreignObject,
    list: list,
    map: map,
    maybe: maybe,
    tuple: tuple,
    AtIndex: Data_Codec_Argonaut.AtIndex,
    AtKey: Data_Codec_Argonaut.AtKey,
    MissingValue: Data_Codec_Argonaut.MissingValue,
    Named: Data_Codec_Argonaut.Named,
    TypeMismatch: Data_Codec_Argonaut.TypeMismatch,
    UnexpectedValue: Data_Codec_Argonaut.UnexpectedValue,
    array: Data_Codec_Argonaut.array,
    "boolean": Data_Codec_Argonaut["boolean"],
    "char": Data_Codec_Argonaut["char"],
    decode: Data_Codec_Argonaut.decode,
    encode: Data_Codec_Argonaut.encode,
    fix: Data_Codec_Argonaut.fix,
    index: Data_Codec_Argonaut.index,
    indexedArray: Data_Codec_Argonaut.indexedArray,
    "int": Data_Codec_Argonaut["int"],
    jarray: Data_Codec_Argonaut.jarray,
    jobject: Data_Codec_Argonaut.jobject,
    json: Data_Codec_Argonaut.json,
    "null": Data_Codec_Argonaut["null"],
    number: Data_Codec_Argonaut.number,
    object: Data_Codec_Argonaut.object,
    printJsonDecodeError: Data_Codec_Argonaut.printJsonDecodeError,
    prop: Data_Codec_Argonaut.prop,
    record: Data_Codec_Argonaut.record,
    recordProp: Data_Codec_Argonaut.recordProp,
    string: Data_Codec_Argonaut.string
};

